import { action } from 'satcheljs';

export interface TRY_VALIDATE_DUMPSTER_QUOTAActionMessage {
    targetWindow: Window | undefined;
}
export const validateDumpsterQuota: (
    targetWindow?: Window
) => TRY_VALIDATE_DUMPSTER_QUOTAActionMessage = action(
    'TRY_VALIDATE_DUMPSTER_QUOTA',
    (targetWindow?: Window): TRY_VALIDATE_DUMPSTER_QUOTAActionMessage => ({
        targetWindow,
    })
);
